import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/common/enums/api-status';
import { CreatePurchaseInvoiceAsync, UpdatePurchaseInvoiceAsync, deletePurchaseInvoiceByIdAsync, downloadPurchaseInvoiceAttachmentAsync, generatePurchaseInvoicePdfAsync, getAllPurchaseInvoiceStatusAsync, getAllPurchaseInvoicesAsync, getOrdersListAsync, getPurchaseInvoiceByIdAsync, getPurchaseInvoiceNumberAsync } from './purchaseInvoiceThunk';
import { AppConsts } from '@application/common/constants/app-consts';
const purchaseInvoicesRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const initialState = {
    status: APIStatus.IDLE,
    purchaseInvoicesRequest: purchaseInvoicesRequest
};
export const purchaseInvoiceSlice = createSlice({
    name: 'purchaseinvoice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPurchaseInvoiceStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPurchaseInvoiceStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoiceStatus = action.payload;
            state.purchaseInvoiceStatusDropdown = action.payload.map((status) => {
                return {
                    label: `${status.name}`,
                    value: status.id
                };
            });
        })
            .addCase(getAllPurchaseInvoiceStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getOrdersListAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getOrdersListAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.orderList = action.payload;
            state.orderListOptions = action.payload.map((order) => {
                return {
                    label: order.orderNumber,
                    value: order.id
                };
            });
        })
            .addCase(getOrdersListAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPurchaseInvoiceNumberAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPurchaseInvoiceNumberAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoiceNumber = action.payload.toString();
        })
            .addCase(getPurchaseInvoiceNumberAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(CreatePurchaseInvoiceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(CreatePurchaseInvoiceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdPurchaseInvoice = action.payload;
        })
            .addCase(CreatePurchaseInvoiceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getPurchaseInvoiceByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getPurchaseInvoiceByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoice = action.payload;
            state.unchangedPurchaseInvoice = action.payload;
        })
            .addCase(getPurchaseInvoiceByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdatePurchaseInvoiceAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdatePurchaseInvoiceAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedPurchaseInvoice = action.payload;
        })
            .addCase(UpdatePurchaseInvoiceAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePurchaseInvoiceByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePurchaseInvoiceByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deletePurchaseInvoiceByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllPurchaseInvoicesAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllPurchaseInvoicesAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.purchaseInvoices = action.payload;
        })
            .addCase(getAllPurchaseInvoicesAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(generatePurchaseInvoicePdfAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(generatePurchaseInvoicePdfAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(generatePurchaseInvoicePdfAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(downloadPurchaseInvoiceAttachmentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(downloadPurchaseInvoiceAttachmentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(downloadPurchaseInvoiceAttachmentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default purchaseInvoiceSlice.reducer;
